import React from 'react';

const FeatureCard = ({ image, icon, title, description }) => (
  // <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
  //   <div className="text-primary-500 text-2xl mb-4">{icon}</div>
  //   <h3 className="text-lg font-semibold mb-2">{title}</h3>
  //   <p className="text-gray-600">{description}</p>
  // </div>
  <div className="bg-primary-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
  <div className="relative h-48 overflow-hidden">
    <img
      src={image}
      alt={title}
      className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
    />
    {/* <div className="absolute top-4 left-4 bg-white p-2 rounded-full shadow-md">
      {icon}
    </div> */}
  </div>
  <div className="p-6">
    <h3 className="text-xl font-normal text-gray-900 mb-3">
      {title}
    </h3>
    {/* <p className="text-gray-600 leading-relaxed">
      {description}
    </p> */}
  </div>
</div>
);

export default FeatureCard;